import gql from "graphql-tag";

export const DETECT_DOCUMENT_ANCHORS = gql`
  mutation DetectDocumentAnchors($file: DocumentTemplateFileInput!) {
    detectDocumentAnchors(file: $file)
  }
`;

export const CREATE_DOCUMENT_TEMPLATE = gql`
  mutation AddDocumentTemplate($data: DocumentTemplateDataInput) {
    addDocumentTemplate(data: $data) {
      id
      name
      status
      anchors
      anchorMappings
    }
  }
`;

export const UPDATE_DOCUMENT_TEMPLATE = gql`
  mutation UpdateDocumentTemplate(
    $where: DocumentTemplateWhereInput
    $data: DocumentTemplateDataInput
  ) {
    updateDocumentTemplate(where: $where, data: $data) {
      id
      name
      anchors
      anchorMappings
      status
    }
  }
`;

export const DELETE_DOCUMENT_TEMPLATE = gql`
  mutation DeleteDocumentTemplate($where: DocumentTemplateWhereInput) {
    deleteDocumentTemplate(where: $where) {
      id
    }
  }
`;

export const PREVIEW_DOCUMENT_TEMPLATE = gql`
  mutation PreviewDocumentTemplate(
    $where: DocumentTemplateWhereInput!
    $mappings: JSONObject
    $payload: JSONObject!
  ) {
    previewDocumentTemplate(
      where: $where
      mappings: $mappings
      payload: $payload
    ) {
      base64
      unresolved
    }
  }
`;

export const SAVE_DOCUMENT_TEMPLATE_DRAFT = gql`
  mutation SaveDocumentTemplateDraft(
    $where: DocumentTemplateWhereInput!
    $data: DocumentTemplateDraftInput!
    $revision: Int
  ) {
    saveDocumentTemplateDraft(where: $where, data: $data, revision: $revision) {
      revision
      content
      updatedDate
    }
  }
`;

export const DISCARD_DOCUMENT_TEMPLATE_DRAFT = gql`
  mutation DiscardDocumentTemplateDraft($where: DocumentTemplateWhereInput!) {
    discardDocumentTemplateDraft(where: $where)
  }
`;

export const SAVE_DOCUMENT_TEMPLATE_DRAFT_FILE = gql`
  mutation SaveDocumentTemplateDraftFile(
    $where: DocumentTemplateWhereInput!
    $file: DocumentTemplateFileInput!
    $revision: Int
  ) {
    saveDocumentTemplateDraftFile(
      where: $where
      file: $file
      revision: $revision
    ) {
      revision
      content
      updatedDate
    }
  }
`;

export const PUBLISH_DOCUMENT_TEMPLATE = gql`
  mutation PublishDocumentTemplate(
    $where: DocumentTemplateWhereInput!
    $revision: Int!
  ) {
    publishDocumentTemplate(where: $where, revision: $revision) {
      id
      name
      s3Key
      status
      anchors
      anchorMappings
      createdDate
      hasUnpublishedChanges
      publishedAt
      usages {
        insurancePlanId
        insurancePlanName
        type
        area
        outputName
        conditions
      }
    }
  }
`;

export const RESTORE_DOCUMENT_TEMPLATE_VERSION = gql`
  mutation RestoreDocumentTemplateVersion(
    $where: DocumentTemplateVersionWhereInput!
    $revision: Int
  ) {
    restoreDocumentTemplateVersion(where: $where, revision: $revision) {
      revision
      content
      updatedDate
    }
  }
`;

export const DUPLICATE_DOCUMENT_TEMPLATE = gql`
  mutation DuplicateDocumentTemplate(
    $where: DocumentTemplateWhereInput!
    $data: DocumentTemplateDuplicateInput!
  ) {
    duplicateDocumentTemplate(where: $where, data: $data) {
      id
      name
      s3Key
      status
      createdDate
      hasUnpublishedChanges
      publishedAt
      usages {
        insurancePlanId
        insurancePlanName
        type
        area
        outputName
        conditions
      }
    }
  }
`;

export const START_DOCUMENT_TEMPLATE_PROPOSALS = gql`
  mutation StartDocumentTemplateProposals(
    $where: DocumentTemplateWhereInput!
    $data: DocumentTemplateProposalsInput!
  ) {
    startDocumentTemplateProposals(where: $where, data: $data)
  }
`;

const documentTemplates = {
  CREATE_DOCUMENT_TEMPLATE,
  UPDATE_DOCUMENT_TEMPLATE,
  DELETE_DOCUMENT_TEMPLATE,
  DETECT_DOCUMENT_ANCHORS,
  PREVIEW_DOCUMENT_TEMPLATE,
  SAVE_DOCUMENT_TEMPLATE_DRAFT,
  DISCARD_DOCUMENT_TEMPLATE_DRAFT,
  SAVE_DOCUMENT_TEMPLATE_DRAFT_FILE,
  PUBLISH_DOCUMENT_TEMPLATE,
  RESTORE_DOCUMENT_TEMPLATE_VERSION,
  DUPLICATE_DOCUMENT_TEMPLATE,
  START_DOCUMENT_TEMPLATE_PROPOSALS,
};

export default documentTemplates;
